import { IPrefilledStatus, PrefilledStatus } from "./PrefilledStatus";
import { ISaveOpportunityDraft, SaveOpportunityDraft } from "./SaveOpportunityDraft";

export interface IOpportunityDraft {
  token: string;
  draft: ISaveOpportunityDraft;
  opportunityId?: string;
  prefilledStatus?: IPrefilledStatus;
}

export class OpportunityDraft {
  public token: string;
  public draft: SaveOpportunityDraft;
  public opportunityId?: string;
  public prefilledStatus?: PrefilledStatus;

  constructor(data: IOpportunityDraft) {
    this.token = data.token;
    this.draft = new SaveOpportunityDraft(data.draft);
    this.opportunityId = data.opportunityId;
    this.prefilledStatus = data.prefilledStatus ? new PrefilledStatus(data.prefilledStatus) : undefined;
  }
}
